module.exports = __webpack_public_path__ + "img/work-flow.2fee561a.png";